module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
    
    /*******************  Localhost ********************/
    // API_ADMIN_URL : "http://localhost:3300/admin/",
    // API_BASE_URL : "http://localhost:3300/",
    // ASSETS_BASE_URL : "http://localhost:3300/",
    S3_BASE_URL: 'https://kc-high.s3.ap-south-1.amazonaws.com/',
    // Public site -- for previewing legacy files that ship in front/public
    FRONT_SITE_URL: 'https://www.kchigh.com',


    /*******************  ALgodev ********************/
    // API_ADMIN_URL : "https://algodev.in:63010/admin/",
    // API_BASE_URL : "https://algodev.in:63010/",
    // ASSETS_BASE_URL : "https://algodev.in:63010/",

    /*******************  Live - online ********************/
    // API_ADMIN_URL : "https://api.kchigh.online/admin/",
    // API_BASE_URL : "https://api.kchigh.online/",
    // ASSETS_BASE_URL : "https://api.kchigh.online/",

    /*******************  Live - com ********************/
    API_ADMIN_URL : "https://api.kchigh.com/admin/",
    API_BASE_URL : "https://api.kchigh.com/",
    ASSETS_BASE_URL : "https://api.kchigh.com/",

}